export enum Url {
  Ingredients = "https://norma.nomoreparties.space/api/ingredients",
  Order = "https://norma.nomoreparties.space/api/orders",
  Login = "https://norma.nomoreparties.space/api/auth/login",
  Register = "https://norma.nomoreparties.space/api/auth/register",
  Logout = "https://norma.nomoreparties.space/api/auth/logout",
  Token = "https://norma.nomoreparties.space/api/auth/token",
  Reset = "https://norma.nomoreparties.space/api/password-reset",
  User = "https://norma.nomoreparties.space/api/auth/user",
  PwdReset = "https://norma.nomoreparties.space/api/password-reset",
  PwdSubmit = "https://norma.nomoreparties.space/api/password-reset/reset",

}

export enum UrlWS {
  All = "wss://norma.nomoreparties.space/orders/all",
  User = "wss://norma.nomoreparties.space/orders",
}
